export default {
    init() {
        this.allowed();
        this.changeRow();
        this.getType();
        this.saveZipcodes();
        this.saveBlockTime();
        this.hideExamples();
    },
    allowed() {
        let $this = this;
        $('body').on('change', '#time-management .allowed', function(e) {
            e.preventDefault();
            let tr = $(this).closest('tr');
            let input = $(tr).find('.mins');
            $this.sendData(tr);
        });
    },
    changeRow() {
        let $this = this;
        $('body').on('change', '#time-management td input[type="text"]', function(e) {
            e.preventDefault();
            let tr = $(this).closest('tr');
            $this.sendData(tr);
        });
    },
    sendData(tr) {
        $.ajax({
            type: 'POST',
            url: '/time-management/save',
            data: ({
                organisation_id: $(tr).data('organisation_id'),
                direction: $(tr).data('direction'),
                type: $(tr).data('type'),
                service: $(tr).data('service'),
                day_of_week: $(tr).data('day_of_week'),
                hour: $(tr).data('hour'),
                mins: $(tr).find('.mins').val(),
                difference: $(tr).find('.difference').val(),
                allowed: $(tr).find('.allowed').prop('checked') ? 1 : 0,
            }),
            success: function (response) {
            },
        });
    },
    getType() {
        $('body').on('click', '#time-management .type', function(e) {
            e.preventDefault();
            let type = $(this).data('type');
            let service = $('#time-management .service.btn-primary').data('service');
            let weekday = $('#time-management .weekday.btn-primary').data('weekday');
            window.location.href='/admin/time-management?type='+type+'&service='+service+'&day_of_week='+weekday;
        });
    },
    saveZipcodes() {
        $('body').on('change', '#time-management #zipcodes', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/time-management/save-zipcodes-exceptions',
                data: ({
                    zipcodes: $(this).val()
                }),
                success: function (response) {
                },
            });
        });
    },
    saveBlockTime() {
        $('body').on('change', '#time-management #block-time', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/time-management/save-block-time',
                data: ({
                    block_time: $(this).val()
                }),
                success: function (response) {
                },
            });
        });
    },
    hideExamples(){
        $('#hide_example').click(function() {
            if ($('#hide_example').text() == 'hide examples') {
                $('#example-area').hide();
                $('#hide_example').text('show examples');
            } else {
                $('#example-area').show();
                $('#hide_example').text('hide examples');
            }
        });
    }
}
